var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Typography, useMediaQuery } from "@mui/material";
import { t } from "i18next";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { EditableDataGrid } from "../../../../../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { MuiPopup } from "../../../../../../../components";
import { useAppSelector } from "../../../../../../../store/hooks";
import { getAvailableQtyByWarehouse } from "../../../../../../stockTransfer/apiCall";
import { MultipleLocationsPopup } from "../../interWarehouseStockTransferRequisition/components/multipleLocationsPopup";
import ActualQuantityCell from "./actualQuantityCell";
import InwardSourceLocationCell from "./inwardSourceLocationCell";
var InterWarehouseInwardPartDetails = function (props) {
    var _props$value, _value$StockTransferR;
    var searchParams = useSearchParams()[0];
    var mode = searchParams.get('mode');
    var _a = useState(), modalProps = _a[0], setModalProps = _a[1];
    var onChange = props.onChange, value = props.value, _b = props.name, name = _b === void 0 ? 'StockTransferRequisitionDetail' : _b, error = props.error;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var crud = useAppSelector(function (state) { return state.crud; });
    var warehouseId = props === null || props === void 0 || (_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.SourceWarehouseId;
    var sourceLocation = [{
            field: 'LocationName',
            headerName: 'Storage location ',
            editable: false,
            flex: 1,
            width: 300
        }, {
            field: 'QuantityAvailable',
            headerName: 'Available Qty',
            editable: false,
            flex: 1,
            width: 300
        }, {
            type: 'number',
            field: 'RequestedQuantity',
            headerName: 'Requested Transfer Qty',
            editable: true,
            flex: 1,
            width: 300
        }];
    var columns = [{
            type: 'searchSelect',
            field: 'Product',
            headerName: 'Part name & code',
            flex: 1,
            headerAlign: 'left',
            minWidth: 250,
            renderCell: function (params) {
                var _params$row, _params$row2, _params$row3, _params$row4;
                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "h5",
                    style: {
                        fontSize: '12px',
                        fontWeight: 400,
                        color: '#1B1D21'
                    }
                }, params !== null && params !== void 0 && (_params$row = params.row) !== null && _params$row !== void 0 && _params$row.ProductName ? "".concat(params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.ProductName) : ""), /*#__PURE__*/ React.createElement(Typography, {
                    style: {
                        fontSize: '12px',
                        fontWeight: 400,
                        color: '#6A7682'
                    }
                }, params !== null && params !== void 0 && (_params$row3 = params.row) !== null && _params$row3 !== void 0 && _params$row3.ProductCode ? "#".concat(params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.ProductCode) : ""));
            }
        }, {
            type: 'string',
            field: 'UOM',
            headerName: 'UOM',
            flex: 1,
            headerAlign: 'left',
            placeholder: "Select UOM",
            minWidth: 150
        }, {
            field: 'MRP',
            headerName: 'M.R.P.',
            flex: 1,
            headerAlign: 'left',
            minWidth: 150
        }, {
            field: 'PurchasePrice',
            headerName: 'Purchase Rate',
            flex: 1,
            headerAlign: 'left',
            minWidth: 150
        }, {
            field: 'AvailableQuantity',
            headerName: 'Available Qty',
            flex: 1,
            headerAlign: 'left',
            valueFormatter: function (value) { return value !== null && value !== void 0 ? value : 0; },
            minWidth: 150
        }, {
            field: 'RequestedQuantity',
            headerName: 'Req. transfer Qty',
            editable: false,
            valueFormatter: function (value) { return value !== null && value !== void 0 ? value : 0; },
            flex: 1,
            headerAlign: 'left',
            minWidth: 150
        }, {
            field: 'ActualTransferredQuantity',
            headerName: 'Transferred Qty',
            editable: false,
            valueFormatter: function (value) { return value !== null && value !== void 0 ? value : 0; },
            flex: 1,
            headerAlign: 'left',
            minWidth: 150
        }, {
            field: 'ActualRecievedQty',
            headerName: 'Actual recieved qty',
            editable: true,
            type: 'number',
            flex: 1,
            align: 'left',
            headerAlign: 'left',
            minWidth: 150,
            renderCell: function (params) {
                var handleSerialNumberSubmit = function (selectedRows, rows) { };
                var handleSerialNumberClick = function (e) { };
                return /*#__PURE__*/ React.createElement(ActualQuantityCell, _extends({}, params, {
                    onButtonClick: handleSerialNumberClick,
                    isSerialized: true
                }));
            },
            valueSetter: function (value, row) {
                var newValue = value > 0 ? value : 0;
                return _objectSpread(_objectSpread({}, row), {}, {
                    ActualRecievedQty: newValue > (row === null || row === void 0 ? void 0 : row.ActualTransferredQuantity) ? row === null || row === void 0 ? void 0 : row.ActualTransferredQuantity : newValue,
                    ShortageQuantity: newValue < (row === null || row === void 0 ? void 0 : row.ActualTransferredQuantity) ? (row === null || row === void 0 ? void 0 : row.ActualTransferredQuantity) - newValue : 0,
                    ExcessQuantity: newValue > (row === null || row === void 0 ? void 0 : row.ActualTransferredQuantity) ? newValue - (row === null || row === void 0 ? void 0 : row.ActualTransferredQuantity) : 0
                });
            }
        }, {
            field: 'SourceLocation',
            headerName: 'Storage Location',
            editable: true,
            flex: 1,
            align: 'left',
            headerAlign: 'left',
            minWidth: 150,
            renderCell: function (params) {
                var handleLocationDetailSubmit = function (selectedRows, rows, rowData) {
                    var _value$name;
                    var filteredData = rows === null || rows === void 0 ? void 0 : rows.filter(function (item) { return selectedRows.includes(item === null || item === void 0 ? void 0 : item.id); });
                    var transformedData = filteredData === null || filteredData === void 0 ? void 0 : filteredData.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                        AvailableQuantity: item.QuantityAvailable
                    }); });
                    var newRows = (_value$name = value[name]) === null || _value$name === void 0 ? void 0 : _value$name.map(function (r) {
                        var _params$row5;
                        return (params === null || params === void 0 || (_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.id) === (r === null || r === void 0 ? void 0 : r.id) ? _objectSpread(_objectSpread({}, r), {}, {
                            SourceLocations: transformedData
                        }) : r;
                    });
                    if (onChange)
                        onChange(null, newRows);
                };
                var getSourceLocations = function (apiParams) { return __awaiter(void 0, void 0, void 0, function () {
                    var _res$data, res, data;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, getAvailableQtyByWarehouse(apiParams)];
                            case 1:
                                res = _a.sent();
                                data = res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.map(function (r) {
                                    var _params$row$SourceLoc, _params$row$SourceLoc2;
                                    return (_params$row$SourceLoc = (_params$row$SourceLoc2 = params.row.SourceLocations) === null || _params$row$SourceLoc2 === void 0 ? void 0 : _params$row$SourceLoc2.find(function (it) { return it.id === r.id; })) !== null && _params$row$SourceLoc !== void 0 ? _params$row$SourceLoc : r;
                                });
                                return [2 /*return*/, {
                                        data: data,
                                        success: true
                                    }];
                        }
                    });
                }); };
                var onSourceLocationClick = function () {
                    var _crud$profilePersonal, _params$row6, _params$row7, _params$row8;
                    var modalProps = {
                        onSubmit: handleLocationDetailSubmit,
                        apiRequest: {
                            TenantId: crud === null || crud === void 0 || (_crud$profilePersonal = crud.profilePersonalDetails) === null || _crud$profilePersonal === void 0 || (_crud$profilePersonal = _crud$profilePersonal.data) === null || _crud$profilePersonal === void 0 || (_crud$profilePersonal = _crud$profilePersonal.Branches[0]) === null || _crud$profilePersonal === void 0 ? void 0 : _crud$profilePersonal.OrganizationId,
                            ProductId: params === null || params === void 0 || (_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.ProductId,
                            WarehouseId: warehouseId
                        },
                        apiCall: getSourceLocations,
                        apiKey: 'getAvailableQty',
                        columns: sourceLocation,
                        title: t('Source location'),
                        data: params === null || params === void 0 || (_params$row7 = params.row) === null || _params$row7 === void 0 ? void 0 : _params$row7.SourceLocations,
                        singleSelection: true,
                        rowData: params.row,
                        selectedRows: (params === null || params === void 0 || (_params$row8 = params.row) === null || _params$row8 === void 0 || (_params$row8 = _params$row8.SourceLocations) === null || _params$row8 === void 0 ? void 0 : _params$row8.map(function (e) { return e === null || e === void 0 ? void 0 : e.id; })) || []
                    };
                    setModalProps(modalProps);
                };
                return /*#__PURE__*/ React.createElement(InwardSourceLocationCell, _extends({}, params, {
                    modalProps: modalProps,
                    onClick: onSourceLocationClick
                }));
            }
        }, {
            type: 'number',
            field: 'ShortageQuantity',
            headerName: 'Shortage qty',
            valueFormatter: function (value) { return value !== null && value !== void 0 ? value : 0; },
            flex: 1,
            headerAlign: 'left',
            minWidth: 150
        }, {
            type: 'number',
            field: 'ExcessQuantity',
            headerName: 'Excess qty',
            valueFormatter: function (value) { return value !== null && value !== void 0 ? value : 0; },
            flex: 1,
            headerAlign: 'left',
            minWidth: 150
        }, {
            type: 'number',
            field: 'DamageQuantity',
            headerName: 'Damage qty',
            valueFormatter: function (value) { return value !== null && value !== void 0 ? value : 0; },
            flex: 1,
            headerAlign: 'left',
            minWidth: 150
        }, {
            type: 'number',
            field: 'TotalCost',
            headerName: 'Total cost',
            valueFormatter: function (value, row) {
                var _row$ActualRecievedQt, _row$PurchasePrice;
                return row !== null && row !== void 0 && row.ActualRecievedQty || row !== null && row !== void 0 && row.PurchasePrice ? "".concat(((_row$ActualRecievedQt = row === null || row === void 0 ? void 0 : row.ActualRecievedQty) !== null && _row$ActualRecievedQt !== void 0 ? _row$ActualRecievedQt : 0) * ((_row$PurchasePrice = row === null || row === void 0 ? void 0 : row.PurchasePrice) !== null && _row$PurchasePrice !== void 0 ? _row$PurchasePrice : 0)) : value;
            },
            flex: 1,
            headerAlign: 'left',
            minWidth: 150
        }, {
            type: 'date',
            field: 'BoxCode',
            headerName: 'Box code',
            valueFormatter: function (value) { return value !== null && value !== void 0 ? value : ""; },
            flex: 1,
            headerAlign: 'left',
            minWidth: 150
        }, {
            type: "string",
            field: 'Remarks',
            headerName: 'Source remarks',
            editable: true,
            flex: 1,
            placeholder: "Enter remarks",
            headerAlign: 'left',
            minWidth: 250
        }, {
            type: "string",
            field: 'RejectRemarks',
            headerName: 'Discrepancy remarks',
            editable: true,
            flex: 1,
            placeholder: "Enter remarks",
            headerAlign: 'left',
            minWidth: 250
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        onChange: onChange,
        disableAddRow: false,
        dataGridHeader: "Part details",
        dataGridProps: {
            rowSelection: true,
            checkboxSelection: true,
            disableRowSelectionOnClick: true,
            hideFooter: true
        },
        rows: (_value$StockTransferR = value === null || value === void 0 ? void 0 : value.StockTransferRequisitionDetail) !== null && _value$StockTransferR !== void 0 ? _value$StockTransferR : [],
        error: error === null || error === void 0 ? void 0 : error['StockTransferRequisitionDetail']
    }), /*#__PURE__*/ React.createElement(MuiPopup, {
        id: "part-location-popup",
        variant: "h1",
        openPopup: Boolean(modalProps),
        onClose: function () {
            setModalProps(undefined);
        },
        closeIcon: true,
        title: modalProps === null || modalProps === void 0 ? void 0 : modalProps.title,
        subTitleStyle: {
            marginTop: "10px",
            color: "#8593A3"
        },
        backdropEnable: true,
        padding: "15px 0px 0px 15px",
        containerStyle: {
            width: lgMode ? '500px' : 'calc(90vw)',
            paddingTop: 0,
            paddingX: "16px"
        }
    }, modalProps && /*#__PURE__*/ React.createElement(MultipleLocationsPopup, _extends({}, modalProps, {
        onClose: function () { return setModalProps(undefined); }
    }))));
};
export default InterWarehouseInwardPartDetails;
